module.exports = __webpack_public_path__ + "img/license-disk-img.d91cd912.png";